<div class="d-flex flex-column flex-grow-1 overflow-auto templateBox">
    <div class="card d-flex flex-column w-100">
        <div class="padding2 pt-2 pb-2 d-flex flex-column flex-grow-1 minHeight15">
            <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center max-w-32 gap25">
                    <div class="h5 template-title text-capitalize text-truncate mb-0" [matTooltip]="template.name">
                        {{template.name}}
                    </div>
                    @if(template.createdBy === CREATED_BY.ME){
                    <button mat-icon-button (click)="goToEdit()">
                        <mat-icon>edit</mat-icon>
                    </button>
                    }
                </div>
                <button mat-icon-button (click)="matDialogRef.close()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>

                <div class="template-date d-flex flex-wrap align-items-center justify-content-between gap-2 mt-2 header-divider">
                <div class="text-muted small fw-medium d-flex align-items-center gap-1" [matTooltip]="'Last Updated At'">
                    <mat-icon>access_time</mat-icon>
                    {{template.createdAt | date}}
                </div>
                <div class="d-flex">
                    <div [matTooltip]="'Category'"
                        class="bgc-light-dark text-capitalize me-1 d-flex align-items-center px-3 capsule">
                        <mat-icon class="me-1">event_note</mat-icon> {{ template.category }}
                    </div>
                    <div [matTooltip]="'Visibility'"
                        class="bgc-light-dark text-capitalize d-flex align-items-center px-3 capsule">
                        <mat-icon class="me-1">visibility</mat-icon>
                        {{ template.privacy === 'individual' ? 'Just Me' : (template.privacy === 'team' ? 'My Team' :
                        'Everyone') }}
                    </div>
                </div>
            </div>

            <div class="template-description">{{template.description}}</div>

            <div class="mb-3 p-2 pt-1 bgc-content overflow-auto text-center descHeight"
                [ngClass]="{'d-flex': isLoading, 'justify-content-center align-items-center': isLoading}">
                <div class="h-100 w-100"
                    [ngClass]="{'d-flex flex-column align-items-center justify-content-center': isLoading}">
                    @if(isLoading){
                    <mat-progress-spinner @zoomIn [diameter]="24" [mode]="'indeterminate'"
                        class="text-secondary"></mat-progress-spinner>
                    <p class="fw-medium text-secondary mt-2">Loading the template, please hold on...</p>
                    }@else if(!isLoading && templateContent) {
                    <div class="text-start small p-3 innerDescDiv" @zoomIn [innerHTML]="templateContent"></div>
                    }
                </div>
            </div>
        </div>
    </div>
</div>